import { useEffect } from 'react';
import { useAuthState, Types } from 'src/contexts';
import { useAuthManagement } from './useAuthManagement';

const TOKEN_REFRESH_INTERVAL_MS = 60_000;

export const AuthBootstrap = () => {
  const { isAuthenticated, isInitialized, dispatch } = useAuthState();
  const { checkAuthenticationStatus, refreshTokenIfNeeded } = useAuthManagement();

  useEffect(() => {
    let isActive = true;

    const initialize = async () => {
      try {
        const { isAuthenticated, profile } = await checkAuthenticationStatus();

        if (!isActive) {
          return;
        }

        if (isAuthenticated && profile) {
          dispatch({
            type: Types.Login,
            payload: { profile },
          });
          return;
        }

        dispatch({ type: Types.Logout });
      } catch (error) {
        console.error('AuthBootstrap: Failed to initialize auth state:', error);

        if (isActive) {
          dispatch({ type: Types.Logout });
        }
      }
    };

    if (!isInitialized) {
      void initialize();
    }

    return () => {
      isActive = false;
    };
  }, [checkAuthenticationStatus, dispatch, isInitialized]);

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const intervalId = window.setInterval(async () => {
      try {
        const isStillAuthenticated = await refreshTokenIfNeeded();

        if (!isStillAuthenticated) {
          dispatch({ type: Types.Logout });
        }
      } catch (error) {
        console.error('AuthBootstrap: Background token refresh failed:', error);
        dispatch({ type: Types.Logout });
      }
    }, TOKEN_REFRESH_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [dispatch, isAuthenticated, refreshTokenIfNeeded]);

  return null;
};
